<template>
    <v-form
        ref="form"
        >
        <v-row>
            <v-col cols="12">
                <v-text-field
                    v-model="form.code"
                    outlined
                    dense
                    hide-details="auto"
                    label="Code"
                    clearable>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.from"
                    outlined
                    dense
                    hide
                    label="From"
                    clearable>
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.to"
                    outlined
                    dense
                    hide
                    label="To"
                    clearable>
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.supplier_id"
                    outlined
                    :items="suppliers"
                    item-value="id"
                    item-text="name"
                    @update:search-input="searchSuppliers"
                    dense
                    hide-details="auto"
                    label="Supplier"
                    clearable>
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                    label="State"
                    outlined
                    dense
                    hide-details="auto"
                    :items="states"
                    v-model="form.state">
                </v-select>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import PDatePicker from "./../../components/common/PDatePicker"
import { mapActions, mapGetters } from 'vuex';
import order from './../../services/purchase/order';
export default {
    name: "PurchaseOrderListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form: {
                code: null,
                from: null,
                to: null,
                supplier_id: null, 
                state: null
            },
            states: []
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/order/params",
            suppliers: "purchase/supplier/list",
            loading: "purchase/supplier/loading"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/order/updateParams",
            searchSuppliers: "purchase/supplier/search"
        }),
        submit() {
            this.updateParams(this.form);
        }
    },
    created() {
        this.form = {...this.params}
        order.states().then(response => this.states = response.data);
    }
    
}
</script>

<style>

</style>